import React from "react";
import { Link } from "react-router-dom";
import { addStaticRootToUrl } from "@src/utils/static";

const NOT_FOUND_HEADING = "Oops! Freckles seems to have buried that page.";
const NOT_FOUND_SUBTEXT =
  "Other reasons you may not be able to view this page:";
const REASON_INVALID_LINK =
  "The page no longer exists so the link you followed is invalid.";
const REASON_TECHNICAL_ISSUES =
  "Our server may be experiencing technical issues.";
const REASON_MISTYPED_URL = "You accidentally mistyped the URL.";
const HOMEPAGE_LINK_TEXT = "Return to the homepage";
const FRECKLES_IMAGE_PATH = "images/freckles_error.png";
const FRECKLES_ALT_TEXT = "Freckles the Dalmatian";

export default function NotFoundPage(): React.JSX.Element {
  return (
    <div
      data-testid="not-found-page"
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "60vh",
        padding: "var(--padding-xl)",
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "var(--padding-xxl)",
          maxWidth: "880px",
          width: "100%",
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "var(--margin-lg)",
            width: "395px",
            flexShrink: 0,
          }}
        >
          <h1
            style={{
              fontFamily: "var(--font-family-display)",
              fontSize: "var(--font-size-heading)",
              fontWeight: "var(--font-weight-bolder)",
              lineHeight: "var(--line-height-heading)",
              color: "var(--default-text-color)",
              margin: 0,
            }}
          >
            {NOT_FOUND_HEADING}
          </h1>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "var(--padding-xs)",
            }}
          >
            <p
              style={{
                fontSize: "var(--font-size-md)",
                lineHeight: "var(--line-height-md)",
                color: "var(--default-text-color)",
                margin: 0,
              }}
            >
              {NOT_FOUND_SUBTEXT}
            </p>
            <ul
              style={{
                fontSize: "var(--font-size-md)",
                lineHeight: "var(--line-height-md)",
                color: "var(--default-text-color)",
                margin: 0,
                paddingLeft: "var(--font-size-xl)",
              }}
            >
              <li>{REASON_INVALID_LINK}</li>
              <li>{REASON_TECHNICAL_ISSUES}</li>
              <li>{REASON_MISTYPED_URL}</li>
            </ul>
            <Link
              to="/"
              data-testid="return-home-link"
              style={{
                color: "var(--primary)",
                fontSize: "var(--font-size-sm)",
                lineHeight: "var(--line-height-sm)",
                textDecoration: "none",
              }}
            >
              {HOMEPAGE_LINK_TEXT}
            </Link>
          </div>
        </div>
        <div style={{ flex: "1 0 0", minWidth: 0 }}>
          <img
            src={addStaticRootToUrl(FRECKLES_IMAGE_PATH)}
            alt={FRECKLES_ALT_TEXT}
            style={{ width: "100%", height: "auto" }}
          />
        </div>
      </div>
    </div>
  );
}
